import colorConvert from 'color-convert';
import { MessagingAttendee } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import VyNoData from '../../../../common/VyNoData';
import AttendeeComponent from './AttendeeComponent';
import ConversationSkeleton from './ConversationSkeleton';
interface AttendeesListInterface {
  attendees?: MessagingAttendee[];
  attendeesCount: number;
  isLoading?: boolean;
  showSkeleton: boolean;
  setOpenConversation?: (attendee: MessagingAttendee) => void;
  loadMoreAttendees?: () => void;
  search?: string;
}
const NBR_OF_ATTENDEES_PER_QUERY = 100;
const AttendeesList = ({ attendees, attendeesCount, isLoading, showSkeleton, search = '', setOpenConversation, loadMoreAttendees }: AttendeesListInterface) => {
  const eventColor = useSelector(({ common }) => common.event?.template.mainColor);
  const isFetching = useSelector((state) => state.common.attendeeMessaging?.isFetchingAttendees);

  const loading = isFetching || isLoading;

  const getRandomColor = () => {
    if (!eventColor) return;
    let color = [216, 97, 34];
    const [h, s] = colorConvert.hex.hsl(eventColor);
    const randomToHundred = Math.floor(Math.random() * 50) + 30;
    color = [h, s, randomToHundred];
    return `hsl(${color[0]}, ${color[1]}%, ${color[2]}%)`;
  };

  return (
    <div className="w-full h-full flex flex-col overflow-x-hidde mb-10">
      {isFetching === true && <ConversationSkeleton />}
      {!loading && (
        <>
          {attendees && attendees?.length > 0 ? (
            attendees
              .filter((a) => a.name?.includes(search))
              .map((attendee, index) => {
                const backgroundColor = getRandomColor();
                return (
                  <AttendeeComponent
                    attendee={{ ...attendee, backgroundColor }}
                    animationIndex={index % NBR_OF_ATTENDEES_PER_QUERY}
                    skipAnimation={index < (attendees.length / NBR_OF_ATTENDEES_PER_QUERY - 1) * NBR_OF_ATTENDEES_PER_QUERY}
                    onClick={() => setOpenConversation?.({ ...attendee, backgroundColor })}
                  />
                );
              })
          ) : attendees !== undefined ? (
            <div className="w-full h-full grid place-items-center">
              <div className="flex flex-col items-center space-y-2">
                <VyNoData />
              </div>
            </div>
          ) : (
            <></>
          )}
          {attendeesCount !== undefined && attendees && showSkeleton && attendeesCount > attendees?.length && (
            <ConversationSkeleton length={3} onSkeletonVisible={() => loadMoreAttendees?.()} />
          )}
        </>
      )}
    </div>
  );
};
export default AttendeesList;
